// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3e5bL","checkboxCol":"Table_checkboxCol__32J9f","emailCol":"Table_emailCol__2FuQL","actionCol":"Table_actionCol__1yvzc"};